import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import { useNavigate } from "react-router-dom";
import "./Capabilities.css";
import codingImage from "../../images/medical-coding.jpg"; // Ensure this path is correct

const MedicalCoding = () => {
  const navigate = useNavigate();
  
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>Medical Coding & Auditing Services</h1>

        {/* Section with Text & Image */}
        <div className="cap-section">
          
          {/* Text Content */}
          <div className="text-content">
            <h2>Accurate Coding & Auditing for Seamless Revenue Cycle</h2>
            <p>
              Accurate and compliant medical coding is essential for proper reimbursement, reduced claim denials, and adherence to healthcare regulations.
              At S&S Healthcare Consulting, we provide expert medical coding services that ensure precise classification of diagnoses, procedures, and treatments.
            </p>
            <p>
              Our certified coders stay updated with the latest ICD-10, CPT, and HCPCS codes, ensuring that your practice receives the maximum reimbursement while maintaining compliance with 
              Medicare, Medicaid, and private insurers.
            </p>
            <p>
              By outsourcing your medical coding to us, you can reduce billing errors, avoid costly penalties, and improve revenue cycle efficiency. 
              Our coders specialize in multiple specialties, including primary care, cardiology, dermatology, orthopedics, surgery, and more.
            </p>
            <button className="cap-button" onClick={() => navigate("/learn-more/medical-coding")}>
              Learn More
            </button>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={codingImage} alt="Medical Coding" />
          </div>

        </div>
      </div>
    </motion.div>
  );
};

export default MedicalCoding;
